import { FullPageLoader } from '@/components/shared/LoadingSpinner'
import { useGlobalFetchingState } from '@/hooks/useGlobalFetchingState'

/**
 * App-wide loading overlay driven by every in-flight React Query query/mutation.
 * Mounted once in App.tsx — no per-page wiring needed. See [[global-loading-and-error-handling]].
 */
export function GlobalLoadingOverlay() {
  const isFetching = useGlobalFetchingState()

  if (!isFetching) return null

  return <FullPageLoader />
}
